export enum UnitType {
    DefaultAreaUnit = 0,
    DefaultForceUnit = 1,
    DefaultTorqueUnit = 2,
    DefaultLengthUnit = 3,
    DefaultPressureUnit = 4,
    DefaultTemperatureUnit = 5,
    DefaultWeightUnit = 6,
    DefaultStressUnit = 7,
    DefaultPercentageUnit = 8,
    DefaultAngleUnit = 9,
}
